export default __webpack_public_path__ + "static/media/pop-up-on.b776a1ef.mp3";